// import Check from '@/pages/exam/check'
import ExamDetail from '@/pages/exam/examDetail';
// import ExamTypeList from '@/pages/exam/examTypeList'
import Exam from '@/pages/exam/exam';
import ExamResult from '@/pages/exam/examResult';
import examLogin from '@/pages/exam/examLogin';
import examChooseTest from '@/pages/exam/examChooseTest';
import Manage from '@/pages/exam/examManage/manage';
import ExamSearch from '@/pages/exam/examManage/examSearch';
import QuestionManage from '@/pages/exam/examManage/questionManage';
import newQuestionManage from '@/pages/exam/examManage/newQuestionManage';
import examTotal from '@/pages/exam/examManage/examTotal';
import paperConfig from '@/pages/exam/examManage/paperConfig';
import paperDetails from '@/pages/exam/examManage/paperDetails';
import paperReview from '@/pages/exam/examManage/paperReview';
import examOnlineMange from '@/pages/exam/examManage/examOnlineMange';
import examSaleQuery from '@/pages/exam/examManage/examSaleQuery';
import riskExamTotal from '@/pages/exam/examManage/examRiskExamTotal';
import examSaleTotal from '@/pages/exam/examManage/examSaleTotal';
import examSaleAuthorize from '@/pages/exam/examManage/examSaleAuthorize';
import internetQuestionManage from '@/pages/exam/examManage/internetQuestionManage';
export default [
  // {
  //   path: '/check/',
  //   name: 'Check',
  //   component: Check
  // },
  {
    path: '/home',
    component: () => import('@/pages/exam/examNew/examHome'),
    children: [
      {
        path: '/examList',
        component: () => import('@/pages/exam/examNew/examList'),
        meta: { title: '销售资格考试' }
      },
      {
        path: '/examCanList',
        component: () => import('@/pages/exam/examNew/examCanList'),
        meta: { title: '销售资格考试' }
      }
    ]
  },
  {
    path: '/examDetail',
    name: 'ExamDetail',
    component: ExamDetail
  },
  // {
  //   path: '/examTypeList',
  //   name: 'ExamTypeList',
  //   component: ExamTypeList
  // },
  {
    path: '/exam',
    name: 'Exam',
    component: Exam
  },
  {
    path: '/examResult',
    name: 'ExamResult',
    component: ExamResult
  },
  // {
  //   path: '/downCount',
  //   name: 'DownCount',
  //   component: DownCount
  // },
  // {
  //   path: '/loginCheck',
  //   name: 'loginCheck',
  //   component: loginCheck
  // },
  {
    path: '/examLogin',
    name: 'examLogin',
    component: examLogin
  },
  {
    path: '/examChooseTest',
    name: 'examChooseTest',
    component: examChooseTest
  },
  {
    path: '/examSearch',
    name: 'examSearch',
    redirect: '/examSearch/paperDetails',
    component: ExamSearch,
    props: { name: '入司考试管理' },
    children: [
      {
        path: '/examSearch/paperDetails',
        name: 'paperDetails',
        component: paperDetails,
        props: { name: '考试明细' }
      },
    ]
  },
  {
    path: '/manage',
    name: 'Manage',
    redirect: '/manage/paperDetails',
    component: Manage,
    props: { name: '入司考试管理' },
    children: [
      {
        path: '/manage/examOnlineMange',
        name: 'examOnlineMange',
        component: examOnlineMange,
        props: { name: '险种试卷上线管理' }
      },
      {
        path: '/manage/examSaleQuery',
        name: 'examSaleQuery',
        component: examSaleQuery,
        props: { name: '销售人员可售清单查询' }
      },
      {
        path: '/manage/questionManage',
        name: 'QuestionManage',
        component: QuestionManage,
        props: { name: '题库管理' }
      },
      {
        path: '/manage/questionManage',
        name: 'QuestionManage',
        component: QuestionManage,
        props: { name: '题库管理' }
      },
      {
        path: '/manage/newQuestionManage',
        name: 'newQuestionManage',
        component: newQuestionManage,
        props: { name: '险种题库列表' }
      },
      {
        path: '/manage/internetQuestionManage',
        name: 'internetQuestionManage',
        component: internetQuestionManage,
        props: { name: '互联网题库管理' }
      },
      {
        path: '/manage/examTotal',
        name: 'examTotal',
        component: examTotal,
        props: { name: '考试汇总' }
      },
      {
        path: '/manage/riskExamTotal',
        name: 'riskExamTotal',
        component: riskExamTotal,
        props: { name: '险种考试汇总查询' }
      },
      {
        path: '/manage/paperConfig',
        name: 'paperConfig',
        component: paperConfig,
        props: { name: '试卷配置' }
      },
      {
        path: '/manage/paperDetails',
        name: 'paperDetails',
        component: paperDetails,
        props: { name: '考试明细' }
      },
      {
        path: '/manage/paperReview',
        name: 'paperReview',
        component: paperReview,
        props: { name: '试题复现' }
      },
      {
        path: '/manage/examSaleTotal',
        name: 'examSaleTotal',
        component: examSaleTotal,
        props: { name: '销售人员可售汇总' }
      },
      {
        path: '/manage/examSaleAuthorize',
        name: 'examSaleAuthorize',
        component: examSaleAuthorize,
        props: { name: '销售人员授权汇总' }
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/exam.js